import React, {Component} from 'react';
import * as d3 from 'd3';
import './transport.min.css';

const FILL = 0.48;

class Transport extends Component{
  constructor(props){
    super(props);
    console.log(this.props.data);
    this.data = this.props.data.filter(d => d.group === this.props.cat).sort((a,b) => a.name.localeCompare(b.name));
    // this.data = this.data.sort((a,b) => +b.nn - +a.nn);
    // this.data = data.sort((a,b) => a.id.localeCompare(b.id)), d => d.id
    this.subgroups = d3.nest().key(d => d.subgroup).entries(this.data);
    this.subgroup_order = ['Air', 'Land', 'Sea'];
    console.log(this.subgroups);
    this.numRow = this.data.length/this.subgroups.length;
    this.state = {dim: null};
  }

  componentDidMount(){
    const dim = this.ref.getBoundingClientRect();
    this.emoji_size =  Math.sqrt(dim.height*dim.width*FILL/this.data.length);
    this.box_height = dim.height/this.numRow;
    console.log(this.box_height);
    this.setState({dim: dim});
  }

  render(){
    return(
      <div className='table' ref={(ref)=> this.ref = ref}>
        {this.subgroups.map(d => {

          return (
            <div key={d.key} id={d.key} className={d.key + ' transport-type'} height='100px'>
              {d.values.map( d => {
                let href = './emojione/' + d.unicode + '.svg';
                return(Array(+d.nn).fill(href).map(src => (<img src={src}></img>)))
            })}
            </div>
          )
        })}
      </div>
    )
  }
}

export default Transport;

// References
// https://mimno.github.io/showcase/project2/got/



// WEBPACK FOOTER //
// ./src/Charts/Transport/Transport.js